import { products } from "../data/products";

export function generateRecommendations(answers) {
  const recommendations = [];
  const { 0: hairType, 1: concern, 2: washFrequency } = answers;

  // Base weights for different factors
  const weights = {
    hairType: 0.4,
    concern: 0.4,
    washFrequency: 0.2,
  };

  // Product scoring based on hair type
  const hairTypeScores = {
    "Type 3A-3C": {
      "Moisturizing Cream": 5,
      "Curl Defining Gel": 5,
      "Leave-in Conditioner": 4,
      "Protein Treatment": 3,
    },
    "Type 4A-4C": {
      "Moisturizing Cream": 5,
      "Hair Butter": 5,
      "Leave-in Conditioner": 5,
      "Growth Oil": 4,
    },
    "Mixed Texture": {
      "Moisturizing Cream": 4,
      "Leave-in Conditioner": 5,
      "Hair Oil": 4,
      "Curl Defining Cream": 4,
    },
  };

  // Product scoring based on concerns
  const concernScores = {
    Dryness: {
      "Moisturizing Cream": 5,
      "Hair Butter": 5,
      "Leave-in Conditioner": 4,
      "Hair Oil": 4,
    },
    Breakage: {
      "Protein Treatment": 5,
      "Strengthening Shampoo": 4,
      "Growth Oil": 4,
      "Leave-in Conditioner": 3,
    },
    Growth: {
      "Growth Oil": 5,
      "Scalp Treatment": 5,
      "Strengthening Shampoo": 4,
      "Protein Treatment": 3,
    },
    Maintenance: {
      "Leave-in Conditioner": 5,
      "Moisturizing Cream": 4,
      "Hair Oil": 4,
      "Curl Defining Cream": 3,
    },
  };

  // Product scoring based on wash frequency
  const washFrequencyScores = {
    Weekly: {
      "Clarifying Shampoo": 5,
      "Protein Treatment": 4,
      "Leave-in Conditioner": 3,
    },
    "Bi-weekly": {
      "Moisturizing Cream": 5,
      "Hair Oil": 4,
      "Leave-in Conditioner": 4,
    },
    Monthly: {
      "Hair Butter": 5,
      "Growth Oil": 4,
      "Deep Conditioner": 5,
    },
  };

  // Calculate total scores for each product
  const productScores = {};

  products.forEach((product) => {
    let score = 0;

    // Hair type score
    if (hairType && hairTypeScores[hairType]?.[product.name]) {
      score += hairTypeScores[hairType][product.name] * weights.hairType;
    }

    // Concern score
    if (concern && concernScores[concern]?.[product.name]) {
      score += concernScores[concern][product.name] * weights.concern;
    }

    // Wash frequency score
    if (washFrequency && washFrequencyScores[washFrequency]?.[product.name]) {
      score +=
        washFrequencyScores[washFrequency][product.name] *
        weights.washFrequency;
    }

    productScores[product.id] = score;
  });

  // Sort products by score and get top 3
  const recommendedProducts = products
    .sort((a, b) => productScores[b.id] - productScores[a.id])
    .slice(0, 3);

  // If we don't have enough recommendations, add featured products
  if (recommendedProducts.length < 3) {
    const featuredProducts = products
      .filter((p) => p.featured && !recommendedProducts.includes(p))
      .slice(0, 3 - recommendedProducts.length);

    recommendedProducts.push(...featuredProducts);
  }

  return recommendedProducts;
}
